import React, {
  createContext, ReactNode, useCallback, useContext, useMemo, useRef,
} from 'react';
import {
  PickerHandle, SelectPicker, SelectPickerProps, Stack,
} from 'rsuite';

interface PickerCloseContextValue {
  close: () => void;
}

const PickerCloseContext = createContext<PickerCloseContextValue>({
  close: () => {},
});

export function SelectPickerWithActions<T>(props: SelectPickerProps<T>): JSX.Element {
  const ref = useRef<PickerHandle>(null);
  const close = useCallback(() => ref.current?.close?.(), []);
  const contextValue = useMemo<PickerCloseContextValue>(() => ({ close }), [close]);

  return (
    <PickerCloseContext.Provider value={contextValue}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <SelectPicker {...props} ref={ref} />
    </PickerCloseContext.Provider>
  );
}

interface SelectOptionWithActionsProps {
  label: ReactNode;
  children: ReactNode;
}

export function SelectOptionWithActions({
  label,
  children,
}: SelectOptionWithActionsProps): JSX.Element {
  const { close } = useContext(PickerCloseContext);

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      style={{ width: '100%' }}
    >
      <Stack spacing={20}>
        <span>{label}</span>
        <Stack
          spacing={5}
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            event.stopPropagation();
            close();
          }}
        >
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
}
